// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__2k4pb","label":"Radio_label__1zZJK","checkMark":"Radio_checkMark__3WUKn","disabled":"Radio_disabled__1nnYO"};